import React from "react";
import S from "./RelatedPosts.styled";
import { IWPRelatedPosts } from "@/src/types";
import { gatsbyImageHelper } from "@/src/helpers";
import Arrow from "@/assets/arrow.svg";
import Wirepas from "./assets/wirepas.svg";

export interface IRelatedPostsProps {
  relatedPosts: IWPRelatedPosts[];
}

const RelatedPosts: React.FC<IRelatedPostsProps> = ({ relatedPosts }) => {
  const renderRelatedPosts = relatedPosts.map(
    ({ title, uri, date, blogInfo, eventsInfo, newsInfo, casesInfo }) => {
      const imageData = gatsbyImageHelper(
        blogInfo?.featuredImage ??
          eventsInfo?.featuredImage ??
          newsInfo?.featuredImage ??
          casesInfo?.featuredImage
      );

      const CardContent = () => {
        return (
          <>
            {imageData ? (
              <S.CardImage image={imageData} alt={title} />
            ) : (
              <S.CardLocalImage>
                <Wirepas />
              </S.CardLocalImage>
            )}
            <S.CardTextWrapper>
              <S.CardTitle>{title}</S.CardTitle>
              <S.CardDate>{date}</S.CardDate>
              <S.CardReadMoreWrapper>
                <S.CardReadMore>Read More</S.CardReadMore>
                <Arrow id="card-arrow" />
              </S.CardReadMoreWrapper>
            </S.CardTextWrapper>
          </>
        );
      };
      return (
        <React.Fragment key={uri}>
          {casesInfo?.localOrExternal === "external" ? (
            <S.CardExternal
              href={casesInfo?.externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              $external={true}
            >
              <CardContent />
            </S.CardExternal>
          ) : (
            <S.Card to={uri} $external={false}>
              <CardContent />
            </S.Card>
          )}
        </React.Fragment>
      );
    }
  );

  return (
    <S.Section>
      <S.Inner>
        <S.RelatedTitle>RELATED POSTS</S.RelatedTitle>
      </S.Inner>
      <S.CardsScroller>
        <S.CardsContainer>{renderRelatedPosts}</S.CardsContainer>
      </S.CardsScroller>
    </S.Section>
  );
};

export default RelatedPosts;
